module.exports = __webpack_public_path__ + "static/media/galfar.b8c02b8c.jpg";